import { ThemeColors } from '@map/types';
import { Entries } from 'type-fest';
import { transluce } from './colorManipulator';

type StaticColors = Record<
  25 | 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 950,
  string
>;

const darkerBg = '#000000';
const shadeLevelsAndOpacity = [
  [25, 0.025],
  [50, 0.05],
  [100, 0.1],
  [200, 0.2],
  [300, 0.5],
  [400, 0.8],
  [500, 1],
  [600, 0.8],
  [700, 0.6],
  [800, 0.4],
  [900, 0.2],
  [950, 0.1],
] as const;

export const makeColorShades = (primaryColor: string) => {
  const shades = {} as StaticColors;

  shadeLevelsAndOpacity.forEach(([shade, opacity]) => {
    if (opacity === 1) {
      return (shades[shade] = primaryColor);
    }
    if (shade > 500) {
      return (shades[shade] = transluce(primaryColor, opacity, darkerBg));
    }
    return (shades[shade] = transluce(primaryColor, opacity));
  });

  return shades;
};

const buildThemeColorsOverride = (customPalette: ThemeColors) => {
  const palettesList = Object.entries(customPalette) as Entries<typeof customPalette>;

  return palettesList.reduce((acc, [type, color]) => {
    if (!color) {
      return acc;
    }

    const colors = makeColorShades(color);

    switch (type) {
      case 'primary':
      case 'error':
      case 'success':
        return {
          ...acc,
          [type]: {
            light: colors[300],
            main: colors[500],
            dark: colors[700],
            ...colors,
          },
        };
      case 'neutrals':
      case 'job':
      case 'education':
      case 'hobby':
        return {
          ...acc,
          [type]: colors,
        };
      default:
        return acc;
    }
  }, {});
};

export default buildThemeColorsOverride;
